import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { DateRangePicker } from 'react-date-range'
class FilterArticles extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filterModalVisible: false,
      selectedCategory: '',
      selectedSiteName: '',
      filterFrom: '',
      filtered: false,

      selectedTime: '',
      selectedTimeObject: '',
      timeSelectionsArr: [
        {
          id: 1,
          type: 'mins',
          value: 10,
        },
        {
          id: 2,
          type: 'mins',
          value: 20,
        },
        {
          id: 3,
          type: 'mins',
          value: 30,
        },
        {
          id: 4,
          type: 'hr',
          value: 1,
        },
        {
          id: 5,
          type: 'hrs',
          value: 2,
        },
        {
          id: 6,
          type: 'hrs',
          value: 3,
        },
        {
          id: 7,
          type: 'hrs',
          value: 6,
        },
        {
          id: 8,
          type: 'hrs',
          value: 12,
        },
        {
          id: 9,
          type: 'hrs',
          value: 24,
        },
      ],
      showAll: false,
    }
  }
  handleModal = (visible) => {
    this.setState({ filterModalVisible: visible })
  }

  closeFilterModal = () => {
    this.setState({
      selectedCategory: '',
      selectedSiteName: '',
      filterModalVisible: false,
      selectedTime: '',
      filtered: false,
    })
  }
  selectCategory = (value) => {
    this.setState({
      selectedCategory: value,
      filterFrom: this.props.filterFrom,
    })
  }
  selectSiteName = (value) => {
    this.setState({
      selectedSiteName: value,
      filterFrom: this.props.filterFrom,
    })
  }

  filterArticles = () => {
    const { filterFrom, selectedCategory, selectedSiteName, selectedTimeObject } = this.state
    this.setState({ filterModalVisible: false, filtered: true })
    this.props.filterArticles(filterFrom, selectedCategory, selectedSiteName, selectedTimeObject)
  }
  resetFilter = () => {
    this.setState({
      filtered: false,
      selectedCategory: '',
      selectedSiteName: '',
      selectedTime: '',
      selectedTimeObject: '',
    })
    this.props.resetFilter(this.props.filterFrom)
  }

  handleSelectTimes = (item) => {
    const currentDate = new Date()
    if (item.type == 'mins') {
      currentDate.setMinutes(currentDate.getMinutes() - item.value)
    }
    if (item.type == 'hrs' || item.type == 'hr') {
      currentDate.setHours(currentDate.getHours() - item.value)
    }
    const fromTime = Math.floor(currentDate.getTime() / 1000)
    const toTime = Math.floor(new Date().getTime() / 1000)
    const dateObj = {
      fromTime: fromTime,
      toTime: toTime,
    }
    this.setState({
      selectedTime: item,
      filterFrom: this.props.filterFrom,
      filtered: true,
      selectedTimeObject: dateObj,
    })
  }

  openDatePicker = () => {
    this.setState({ showDatePicker: true })
  }
  showAllCategoriesAndSites = () => {
    this.setState({ showAll: !this.state.showAll }, () => {
      this.props.showAll(this.state.showAll)
    })
  }
  render() {
    const { filterModalVisible } = this.state
    const showAllbgColor = this.state.showAll ? 'rgba(0, 0, 0, 0.13)' : null
    const categories = this.state.showAll
      ? this.props.configuredSitesAndCategoriesList.configuredCategories
      : this.props.categories
    const siteNames = this.state.showAll
      ? this.props.configuredSitesAndCategoriesList.configuredSites
      : this.props.siteNames
    return (
      <>
        <div
          className=''
          onClick={() => {
            this.handleModal(true)
          }}
        >
          <i className='iconStyle fas fa-filter' />
        </div>
        {this.state.filtered ? (
          <div
            className=' mr-2'
            onClick={() => {
              this.resetFilter()
            }}
          >
            <i className=' iconStyle fas fa-trash' />
          </div>
        ) : null}

        <Modal show={filterModalVisible} onHide={() => this.closeFilterModal()}>
          <Modal.Body>
            {
              <div>
                <text
                  style={{
                    backgroundColor: showAllbgColor,
                  }}
                  class='chipType mr-2'
                  size='sm'
                  onClick={() => this.showAllCategoriesAndSites()}
                >
                  All
                </text>
                <div>
                  {this.state.selectedCategory ? (
                    <text
                      className='chipType mr-2 mb-2'
                      size='sm'
                      onClick={() => this.setState({ selectedCategory: '' })}
                    >
                      {this.state.selectedCategory}
                      <i className='fas fa-times' />
                    </text>
                  ) : null}

                  {this.state.selectedSiteName ? (
                    <text
                      className='chipType mr-2 mb-2'
                      size='sm'
                      onClick={() => this.setState({ selectedSiteName: '' })}
                    >
                      {this.state.selectedSiteName}
                      <i className='fas fa-times' />
                    </text>
                  ) : null}

                  {this.state.selectedTime ? (
                    <text
                      className='chipType mr-2 mb-2'
                      size='sm'
                      onClick={() => this.setState({ selectedTime: '', selectedTimeObject: '' })}
                    >
                      {`${this.state.selectedTime.value} ${this.state.selectedTime.type} ago`}
                      <i className='fas fa-times' />
                    </text>
                  ) : null}
                </div>
                <div>
                  <label>Categories</label>
                </div>
                <div className='timeSelectionOptions'>
                  {categories
                    ? categories.map((item, index) => {
                        const bgColor =
                          this.state.selectedCategory == item ? 'rgba(0, 0, 0, 0.13)' : null
                        return (
                          <text
                            key={index}
                            style={{
                              backgroundColor: bgColor,
                            }}
                            className='chipType mr-2 mb-2'
                            size='sm'
                            onClick={() => this.selectCategory(item)}
                          >
                            {item}
                          </text>
                        )
                      })
                    : null}
                </div>
                <div>
                  <label>Site Names</label>
                </div>
                <div className='timeSelectionOptions'>
                  {siteNames
                    ? siteNames.map((item, index) => {
                        const bgColor =
                          this.state.selectedSiteName == item ? 'rgba(0, 0, 0, 0.13)' : null
                        return (
                          <text
                            style={{
                              backgroundColor: bgColor,
                            }}
                            className='chipType mr-2 mb-2'
                            size='sm'
                            onClick={() => this.selectSiteName(item)}
                          >
                            {item}
                          </text>
                        )
                      })
                    : null}
                </div>
                <div>
                  <div>
                    <label>By Time</label>
                  </div>

                  <div className='timeSelectionOptions'>
                    {this.state.timeSelectionsArr.map((item, index) => {
                      return (
                        <text
                          style={{
                            backgroundColor:
                              this.state.selectedTime.id == item.id ? 'rgba(0, 0, 0, 0.13)' : null,
                          }}
                          className='chipType mr-2 mb-2'
                          size='sm'
                          onClick={() => this.handleSelectTimes(item)}
                        >
                          {`${item.value} ${item.type} ago`}
                        </text>
                      )
                    })}
                  </div>
                </div>
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeFilterModal()}>Cancel</Button>
            <Button onClick={() => this.filterArticles()}>Filter</Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}

export default FilterArticles
